class WCRenderer extends WCObservable(WCDummy) {
  static get tag() {
    return "wc-renderer";
  }

  constructor() {
    super({ tag: WCRenderer.tag });

    this.append(
      this.appendStyles(
        `${WCRenderer.tag}{min-width:1px;min-height:1px;display: contents;background-color: inherit}`
      )
    );

    this.handleJS = this.handleJS.bind(this);
  }

  connectedCallback() {
    if (this.trigger) {
      this.handleTrigger = this.handleTrigger.bind(this);
      this.trigger.forEach((trigger) => {
        document.querySelectorAll(trigger)?.forEach((elem) => {
          elem?.addEventListener("mouseenter", this.handleTrigger);
        });
      });
    } else {
      this.initObserver({
        once: this.once,
      });
    }
  }
  disconnectedCallback() {
    if (this.trigger) {
      this.trigger.forEach((trigger) => {
        document.querySelectorAll(trigger)?.forEach((elem) => {
          elem?.removeEventListener("mouseenter", this.handleTrigger);
        });
      });
    }
  }

  get once() {
    return this.hasAttribute("once");
  }

  get lazy() {
    return this.hasAttribute("lazy");
  }

  get context() {
    return this.getAttribute("context") || "/";
  }

  get ressources() {
    return this.getAttribute("ressources")?.split(",") || [];
  }

  get trigger() {
    return this.getAttribute("trigger")?.split(",") || [];
  }

  rerender() {
    this.#render();
  }

  handleTrigger(e) {
    if (this.once) {
      e.currentTarget.removeEventListener("mouseenter", this.handleTrigger);
    }
    this.#render();
  }

  observerCallback(entries) {
    entries.forEach((entry) => {
      if (entry.intersectionRatio > 0) {
        this.#render();
      } else {
      }
    });
  }

  #render() {
    fetch(this.context)
      .then((d) => d.text())
      .then((d) => {
        const doc = parseHTML(d);
        this.ressources.forEach((ressource) => {
          const criterion = `[id*='${ressource}']`;
          const canidate = doc.querySelector(criterion);
          if (canidate) {
            const node = this.querySelector(criterion);
            if (!node) {
              this.append(canidate);
              this.handleJS();
            } else if (node.isEqualNode(canidate)) {
              node.outerHTML = canidate.outerHTML;
              this.handleJS();
            } else {
              node.remove();
              this.append(canidate);
              this.handleJS();
            }
          }
        });
      });
  }

  handleJS() {
    const scripts = this.querySelectorAll("script[type=module]");
    scripts.forEach((script) => {
      const newScript = document.createElement("script");
      newScript.appendChild(document.createTextNode(script.innerHTML));
      newScript.setAttribute("type", "module");
      if (script.id) {
        newScript.setAttribute("id", script.id);
      }
      script.parentNode.replaceChild(newScript, script);
    });
  }
}

customElements.define(WCRenderer.tag, WCRenderer);
